export default __webpack_public_path__ + "static/media/17t.220b0f56.jpg";